const customCssMixins = {
  async mounted() {
    if (this.$customCssProject.includes(this.$route.params.projectSlug)) {
      await import('@/custom-css/' + this.$route.params.projectSlug + '.css')
    } else {
      await import('@/custom-css/ptt-default.css')
    }
  },
}

export default customCssMixins
